export default __webpack_public_path__ + "static/media/bunnyhead-max.90eb2dcd.svg";